import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_FAILURE,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CLEAR,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_FILTER,

    TrialInstitutionLaboratoryContractAction
} from '../actions/trialInstitutionLaboratoryContract';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionLaboratoryContractState {
    formData: Dtos.TrialInstitutionLaboratoryContract | Dtos.TrialInstitutionLaboratoryContract[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    validateState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    deleteState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionLaboratoryContract[];
    formLength: number;
}

const initialState: ITrialInstitutionLaboratoryContractState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    deleteState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialInstitutionLaboratoryContractState, _isLoading: boolean): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialInstitutionLaboratoryContractState,
    formData: Dtos.TrialInstitutionLaboratoryContract | Dtos.TrialInstitutionLaboratoryContract[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: ITrialInstitutionLaboratoryContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: ITrialInstitutionLaboratoryContractState, formFilter: IFormFilter): ITrialInstitutionLaboratoryContractState {

    const items: Dtos.TrialInstitutionLaboratoryContract[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (
            formFilter.search == "" ||
            p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1
        )) : undefined;

    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionLaboratoryContractState, propertiesToClear?: string[]): ITrialInstitutionLaboratoryContractState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionLaboratoryContractState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialInstitutionLaboratoryContractState, _isSaving: boolean): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionLaboratoryContractState,
    formData: Dtos.TrialInstitutionLaboratoryContract | Dtos.TrialInstitutionLaboratoryContract[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionLaboratoryContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function validating(state: ITrialInstitutionLaboratoryContractState, _isValidating: boolean): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialInstitutionLaboratoryContractState,
    formData: Dtos.TrialInstitutionLaboratoryContract | Dtos.TrialInstitutionLaboratoryContract[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialInstitutionLaboratoryContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionLaboratoryContractState, _isCreating: boolean): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionLaboratoryContractState,
    formData: Dtos.TrialInstitutionLaboratoryContract,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionLaboratoryContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function deleting(state: ITrialInstitutionLaboratoryContractState, _isDeleting: boolean): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function deleteSuccess(
    state: ITrialInstitutionLaboratoryContractState,
): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function deleteFailure(state: ITrialInstitutionLaboratoryContractState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractState {
    const newState: ITrialInstitutionLaboratoryContractState = update(state, {
        deleteState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

const TrialInstitutionLaboratoryContractReducer: Reducer<ITrialInstitutionLaboratoryContractState> = (state: ITrialInstitutionLaboratoryContractState = initialState, action: TrialInstitutionLaboratoryContractAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID:
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE:
            return saving(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE:
            return deleting(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_SUCCESS:
            return deleteSuccess(state);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_FAILURE:
            return deleteFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default TrialInstitutionLaboratoryContractReducer;